import { create } from 'zustand';

type DragState = {
  draggingNodeId: string | null;
  hoveredEdgeId: string | null;
  position: { x: number; y: number } | null;
  setDraggingNode: (
    id: string | null,
    position: { x: number; y: number } | null
  ) => void;
  setHoveredEdge: (id: string | null) => void;
};

export const useDragMonitor = create<DragState>((set) => ({
  draggingNodeId: null,
  position: null,
  hoveredEdgeId: null,
  setDraggingNode: (id, position) => set({ draggingNodeId: id, position }),
  setHoveredEdge: (id) => set({ hoveredEdgeId: id }),
}));
